import { useEffect, useState } from "react";

/**
 * `Date.now()`, re-rendering the caller every `intervalMs`.
 *
 * Relative labels are computed at render time, so without a tick they report
 * the age at the last fetch rather than the age now. On the Workers page that
 * is not merely stale but wrong: the Online badge compares `last_seen_at`
 * against a two-minute window, so a worker that died stays green until
 * something happens to trigger a render.
 *
 * No visibility handling on purpose — browsers already throttle a background
 * tab's interval to roughly once a minute, which is the right amount of work
 * for a tab nobody is looking at.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
